const productImageScales = {
  'amirtha-ras-forte-capsules': 1.12,
  'arthadyne-capsules': 1.14,
  'arthonex-capsules': 1.8,
  'biosole-capsules': 1.28,
  'black-capsules': 1.04,
  'cerebran-capsules': 1.02,
  'dermin-capsules': 1.38,
  'devaras-syrup': 1.02,
  'feronin-syrup': 1.04,
  'gynosal-syrup': 1,
  'juran-capsules': 1.18,
  'liver-tone-capsules': 1.42,
  'long-well-capsules': 1.12,
  'long-well-syrup': 1.02,
  'lungtone-capsules': 1.36,
  'myocardin-syrup': 1.08,
  'pachai-thailam-oil': 1.14,
  'toran-syrup': 1.03
};

function getProductImageScale(slug) {
  return productImageScales[slug] || 1;
}

export { getProductImageScale };
